import Image from 'next/image'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Center } from '../../../parts/bases/Center'
import { HStack } from '../../../parts/bases/HStack'
import { Text } from '../../../parts/bases/Text'
import metamaskLogo from '../../../../../public/images/metamaskLogo.png'
import { PinkNeonButton } from '@/src/views/parts/buttons/PinkNeonButton'

export type Props = {
  visible: boolean
  onClickInstall: () => void
}

export const Layout = ({ children, visible, onClickInstall }: PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  return (
    <>
      {visible ? (
        <Center className="relative">
          <PinkNeonButton type="Sub" size="S" onClick={onClickInstall}>
            <HStack className="items-center justify-center ">
              <Center className="relative mr-2 aspect-[99/90] w-4">
                <Image src={metamaskLogo} layout="fill" alt="" />
              </Center>
              <Text className="text-sm text-white">{t('MetamaskInstallChecker.AlertDescription')}</Text>
            </HStack>
          </PinkNeonButton>
        </Center>
      ) : (
        children
      )}
    </>
  )
}
